import React from 'react'

const PlanContext = React.createContext(()=>{});

export const PlanProvider = PlanContext.Provider
export const PlanConsumer = PlanContext.Consumer

export default PlanContext